import { Action, createReducer, on } from '@ngrx/store';

// Actions
import * as AccountLeadDataActions from './accountLeadData.actions';

// States
import { AccountTypesState, AnnualRevenuesState, CurrenciesState, EmployeeCountsState, IndustriesState, OwnershipsState, RatingsState, 
    TimezonesState } from './accountLeadData.state';

export const initialState = [];

// Reducer for Account Types
const accountTypesReducer = createReducer(
    initialState,
    on(AccountLeadDataActions.getAccountTypes, state => state),
    on(AccountLeadDataActions.successGetAccountTypes, (state: AccountTypesState[], { payload }) => {
        return payload;
    }),
    on(AccountLeadDataActions.errorAccountTypes, (state: AccountTypesState[], error: Error) => {
        return { ...state, error };
    })
);

export function AccountTypesReducer(state: AccountTypesState[] | [], action: Action) {
    return accountTypesReducer(state, action);
}

// Reducer for Annual Revenues
const annualRevenuesReducer = createReducer(
    initialState,
    on(AccountLeadDataActions.getAnnualRevenues, state => state),
    on(AccountLeadDataActions.successGetAnnualRevenues, (state: AnnualRevenuesState[], { payload }) => {
        return payload;
    }),
    on(AccountLeadDataActions.errorAnnualRevenues, (state: AnnualRevenuesState[], error: Error) => {
        return { ...state, error };
    })
);

export function AnnualRevenuesReducer(state: AnnualRevenuesState[] | [], action: Action) {
    return annualRevenuesReducer(state, action);
}

// Reducer for Currencies
const currenciesReducer = createReducer(
    initialState,
    on(AccountLeadDataActions.getCurrencies, state => state),
    on(AccountLeadDataActions.successGetCurrencies, (state: CurrenciesState[], { payload }) => {
        return payload;
    }),
    on(AccountLeadDataActions.errorCurrencies, (state: CurrenciesState[], error: Error) => {
        return { ...state, error };
    })
);

export function CurrenciesReducer(state: CurrenciesState[] | [], action: Action) {
    return currenciesReducer(state, action);
}

// Reducer for Employee Counts
const employeeCountsReducer = createReducer(
    initialState,
    on(AccountLeadDataActions.getEmployeeCounts, state => state),
    on(AccountLeadDataActions.successGetEmployeeCounts, (state: EmployeeCountsState[], { payload }) => {
        return payload;
    }),
    on(AccountLeadDataActions.errorEmployeeCounts, (state: EmployeeCountsState[], error: Error) => {
        return { ...state, error };
    })
);

export function EmployeeCountsReducer(state: EmployeeCountsState[] | [], action: Action) {
    return employeeCountsReducer(state, action);
}

// Reducer for Industries
const industriesReducer = createReducer(
    initialState,
    on(AccountLeadDataActions.getIndustries, state => state),
    on(AccountLeadDataActions.successGetIndustries, (state: IndustriesState[], { payload }) => {
        return payload;
    }),
    on(AccountLeadDataActions.errorIndustries, (state: IndustriesState[], error: Error) => {
        return { ...state, error };
    })
);

export function IndustriesReducer(state: IndustriesState[] | [], action: Action) {
    return industriesReducer(state, action);
}

// Reducer for Ownerships
const ownershipsReducer = createReducer(
    initialState,
    on(AccountLeadDataActions.getOwnerships, state => state),
    on(AccountLeadDataActions.successGetOwnerships, (state: OwnershipsState[], { payload }) => {
        return payload;
    }),
    on(AccountLeadDataActions.errorOwnerships, (state: OwnershipsState[], error: Error) => {
        return { ...state, error };
    })
);

export function OwnershipsReducer(state: OwnershipsState[] | [], action: Action) {
    return ownershipsReducer(state, action);
}

// Reducer for Ratings
const ratingsReducer = createReducer(
    initialState,
    on(AccountLeadDataActions.getRatings, state => state),
    on(AccountLeadDataActions.successGetRatings, (state: RatingsState[], { payload }) => {
        return payload;
    }),
    on(AccountLeadDataActions.errorRatings, (state: RatingsState[], error: Error) => {
        return { ...state, error };
    })
);

export function RatingsReducer(state: RatingsState[] | [], action: Action) {
    return ratingsReducer(state, action);
}

// Reducer for Timezones
const timezonesReducer = createReducer(
    initialState,
    on(AccountLeadDataActions.getTimezones, state => state),
    on(AccountLeadDataActions.successGetTimezones, (state: TimezonesState[], { payload }) => {
        return payload;
    }),
    on(AccountLeadDataActions.errorTimezones, (state: TimezonesState[], error: Error) => {
        return { ...state, error };
    })
);

export function TimezonesReducer(state: TimezonesState[] | [], action: Action) {
    return timezonesReducer(state, action);
}